// ============================================================
// SecaoDesempenho.js — Avaliação de Desempenho (Fase 8)
//
// Placeholder por enquanto. O título, o selo "Em breve" e a descrição
// agora vêm do App.js (metadados por página, fonte única pra todas as
// telas) — este arquivo só cuida do conteúdo abaixo disso.
// ============================================================

import { Card } from "../componentes";
import { CINZA_ESC, TEXTO, AZUL_CLARO, AZUL } from "../tema";

export default function SecaoDesempenho() {
  return (
    <Card style={{ padding: "20px 22px" }}>
      <div style={{ fontWeight: 800, fontSize: 15, color: TEXTO, marginBottom: 16 }}>
        O que será acompanhado
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0,1fr))", gap: 14 }}>
        <div style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 16 }}>
          <div style={{ fontSize: 22, marginBottom: 8 }}>🏃</div>
          <div style={{ fontWeight: 700, fontSize: 14, color: TEXTO, marginBottom: 6 }}>Avaliações físicas</div>
          <div style={{ fontSize: 12.5, color: CINZA_ESC, lineHeight: 1.6 }}>
            Agilidade, velocidade, reação, coordenação, impulsão e resistência abdominal.
          </div>
        </div>
        <div style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 16 }}>
          <div style={{ fontSize: 22, marginBottom: 8 }}>📋</div>
          <div style={{ fontWeight: 700, fontSize: 14, color: TEXTO, marginBottom: 6 }}>Avaliação técnica</div>
          <div style={{ fontSize: 12.5, color: CINZA_ESC, lineHeight: 1.6 }}>
            Habilidades e critérios específicos definidos para cada modalidade.
          </div>
        </div>
        <div style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 16 }}>
          <div style={{ fontSize: 22, marginBottom: 8 }}>📈</div>
          <div style={{ fontWeight: 700, fontSize: 14, color: TEXTO, marginBottom: 6 }}>Evolução</div>
          <div style={{ fontSize: 12.5, color: CINZA_ESC, lineHeight: 1.6 }}>
            Comparação entre avaliações, pontos fortes e necessidades de desenvolvimento.
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, alignItems: "flex-start", background: AZUL_CLARO, borderRadius: 8, padding: "12px 14px", marginTop: 16 }}>
        <span style={{ fontSize: 16 }}>ℹ️</span>
        <span style={{ fontSize: 12.5, color: AZUL, lineHeight: 1.6 }}>
          Os resultados auxiliarão a equipe técnica e a coordenação no acompanhamento individual dos
          atletas e no direcionamento dos treinamentos.
        </span>
      </div>
    </Card>
  );
}
